import React from "react"
import { OrderPaymentZaver } from "lib/types/generated/graphql-types"
import { getPaymentMethodDisplayName } from "helpers/getPaymentDisplayName"
import { Label } from "components/Ui/List/List"
import { Container, LogoWrapper, Row, StatusWrapper } from "./Styled"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import StatusSmall from "../../../../../components/Ui/Status/StatusSmall"
import { getProviderLogo } from "helpers/providers"

type Props = {
  orderPayment: OrderPaymentZaver
}

const Zaver = ({ orderPayment }: Props) => {
  if (!orderPayment) return null

  return (
    <>
      <Container>
        <Row>
          <ListEntry
            label={"Payment provider"}
            value={<LogoWrapper>{getProviderLogo(orderPayment.providerName)}</LogoWrapper>}
          />{" "}
          <ListEntry
            label={"Payment method"}
            value={getPaymentMethodDisplayName(orderPayment.method)}
          />
          <ListEntry label={"Payment reference"} value={orderPayment.reference} />
          <ListEntry label={"Provider ID"} value={orderPayment.providerId} />
          <ListEntry
            label={"Verified address"}
            value={orderPayment.useVerifiedAddress ? "Verified" : "Not verified"}
          />
        </Row>
      </Container>
      <Container>
        <Row>
          <div>
            <Label>Payment status</Label>
            <StatusWrapper>
              <StatusSmall status={orderPayment.status.toUpperCase()} />
            </StatusWrapper>
          </div>
        </Row>
      </Container>
    </>
  )
}

export default Zaver
